import { render, staticRenderFns } from "./TourOrderKanbanView.vue?vue&type=template&id=65311f54&scoped=true&lang=pug&"
import script from "./TourOrderKanbanView.vue?vue&type=script&lang=js&"
export * from "./TourOrderKanbanView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65311f54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
